// App version - keep this in sync with the root version file
const APP_VERSION = '2.77.2';

export default APP_VERSION;
